import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'child',
    component: Home
  },
  // 教学考务管理
  {
    path: '/',
    name: 'appStudentAndTeacher',
    component: Home,
    children:[
      // 合同签约
      {
        path: '/appStudentAndTeacher/contractAward',
        name: 'contractAward',
        component: () => import(/* webpackChunkName: "appStudentAndTeacher" */ '@/views/appStudentAndTeacher/contractAward/index')
      },
      // 线上学员管理
      {
        path: '/appStudentAndTeacher/onlineStudents',
        name: 'onlineStudents',
        component: () => import(/* webpackChunkName: "appStudentAndTeacher" */ '@/views/appStudentAndTeacher/onlineStudents/index')
      },
      // 学员课程管理
      {
        path: '/appStudentAndTeacher/studentCourse',
        name: 'studentCourse',
        component: () => import(/* webpackChunkName: "appStudentAndTeacher" */ '@/views/appStudentAndTeacher/studentCourse/index')
      },
      // 人才库管理
      {
        path: '/appStudentAndTeacher/talentPool',
        name: 'talentPool',
        component: () => import(/* webpackChunkName: "appStudentAndTeacher" */ '@/views/appStudentAndTeacher/talentPool/index.vue')
      },
      // 实操作业管理
      {
        path: '/appStudentAndTeacher/workManage',
        name: 'workManage',
        component: () => import(/* webpackChunkName: "appStudentAndTeacher" */ '@/views/appStudentAndTeacher/workManage/index.vue')
      },
    ]
  },
  // 班级服务管理
  {
    path: '/',
    name: 'class',
    component: Home,
    children: [
      // 班级服务管理 - 课时管理
      {
        path: '/class/lesperiod',
        name: 'lesperiod',
        component: () => import(/* webpackChunkName: "class" */ '@/views/class/lesperiod')
      },
      // 班级服务管理 - 课件管理
      {
        path: '/class/lesperiodDoc',
        name: 'lesperiodDoc',
        component: () => import(/* webpackChunkName: "class" */ '@/views/class/lesperiodDoc')
      },
      // 班级服务管理 - 课程管理
      {
        path: '/class/courseManage',
        name: 'CourseManage',
        component: () => import(/* webpackChunkName: "class" */ '@/views/class/courseManage')
      },
      // 班级服务管理 - 项目管理
      {
        path: '/class/projectManage',
        name: 'ProjectManage',
        component: () => import(/* webpackChunkName: "class" */ '@/views/class/projectManage')
      },
      // 班级服务管理 - 班级管理
      {
        path: '/class/classManage',
        name: 'ClassManage',
        component: () => import(/* webpackChunkName: "class" */ '@/views/class/classManage')
      },
      // 班级服务管理 - 公开课管理
      {
        path: '/class/publicClassManage',
        name: 'PublicClassManage',
        component: () => import(/* webpackChunkName: "class" */ '@/views/class/classManage/public')
      },
      // 班级服务管理 - 协议模板管理
      {
        path: '/class/modelAgreement',
        name: 'ModelAgreement',
        component: () => import(/* webpackChunkName: "class" */ '@/views/class/modelAgreement')
      },
    ]
  },
  // 合作机构管理
  {
    path: '/',
    name: 'organization',
    component: Home,
    children: [
      // 合作机构管理 - 合作申请
      {
        path: '/organization/teamApply',
        name: 'TeamApply',
        component: () => import('@/views/organization/teamApply')
      },
      // 合作机构管理 - 教务服务方管理
      {
        path: '/organization/agencyManage',
        name: 'AgencyManage',
        component: () => import('@/views/organization/agencyManage')
      },
      // 合作机构管理 - 招生服务方管理
      {
        path: '/organization/distributionManage',
        name: 'DistributionManage',
        component: () => import('@/views/organization/distributionManage')
      },
      // 合作机构管理 - 招生服务方审核
      {
        path: '/organization/distributionAudit',
        name: 'DistributionAudit',
        component: () => import('@/views/organization/distributionAudit')
      },
      // 合作机构管理 - 招生服务方审核
      {
        path: '/organization/violationNotice',
        name: 'ViolationNotice',
        component: () => import('@/views/organization/violationNotice')
      },
      // 合作机构管理 - 平台数据看板
      {
        path: '/organization/platformData',
        name: 'PlatformData',
        component: () => import('@/views/organization/platformData')
      },
      // 合作机构管理 - 退费数据看板
      {
        path: '/organization/refundPlatformData',
        name: 'RefundPlatformData',
        component: () => import('@/views/organization/platformData/refund')
      },
    ]
  },
  // 订单管理
  {
    path: '/',
    name: 'orderAdmin',
    component: Home,
    children: [
      // 订单管理 - 订单列表
      {
        path: "/orderAdmin/orderList",
        name: "OrderList",
        component: () => import(/* webpackChunkName: "orderAdmin" */ '@/views/orderAdmin/orderList')
      },
      // 订单管理 - 对公转账订单
      {
        path: "/orderAdmin/publicTransfer",
        name: "PublicTransfer",
        component: () => import(/* webpackChunkName: "orderAdmin" */ '@/views/orderAdmin/publicTransfer')
      },
      // 订单管理 - 发票申请列表
      {
        path: "/orderAdmin/invoiceList",
        name: "InvoiceList",
        component: () => import(/* webpackChunkName: "orderAdmin" */ '@/views/orderAdmin/invoiceList')
      },
      // 订单管理 - 结算单管理
      {
        path: "/orderAdmin/billList",
        name: "BillList",
        component: () => import(/* webpackChunkName: "orderAdmin" */ '@/views/orderAdmin/billManage')
      },
      // 订单管理 - 销售订单数据
      {
        path: "/orderAdmin/saleOrderList",
        name: "SaleOrderList",
        component: () => import(/* webpackChunkName: "orderAdmin" */ '@/views/orderAdmin/saleOrderList')
      },
      // 订单管理 - 验收单管理
      {
        path: "/orderAdmin/receiptManage",
        name: "ReceiptManage",
        component: () => import(/* webpackChunkName: "orderAdmin" */ '@/views/orderAdmin/receiptManage')
      },
      // 订单管理 - 验收单管理 - 订单侧
      {
        path: "/orderAdmin/receiptManageByorder",
        name: "ReceiptManageByorder",
        component: () => import(/* webpackChunkName: "orderAdmin" */ '@/views/orderAdmin/receiptManageByorder')
      },
      // 订单管理 - 内训报名订单
      {
        path: "/orderAdmin/internalOrderList",
        name: "InternalOrderList",
        component: () => import(/* webpackChunkName: "orderAdmin" */ '@/views/orderAdmin/internalOrderList')
      },
    ]
  },
  // 退费工作台
  {
    path: '/',
    name: 'refund',
    component: Home,
    children: [
      // 退费工作台 - 退费工单列表
      {
        path: "/refund/refundOrder",
        name: "RefundOrder",
        component: () => import(/* webpackChunkName: "refund" */ '@/views/refund/refundOrder')
      },
    ]
  },
  // 笔试考务管理
  {
    path: '/',
    name: 'writtenExamManagement',
    component: Home,
    children: [
      // 笔试考务管理 - 笔试成绩
      {
        path: "/writtenExam/writtenGrade",
        name: "writtenGrade",
        component: () => import(/* webpackChunkName: "refund" */ '@/views/writtenExam/writtenGrade')
      },
      // 笔试考务管理 - 考场管理
      {
        path: "/writtenExam/roomManagement",
        name: "roomManagement",
        component: () => import(/* webpackChunkName: "refund" */ '@/views/writtenExam/roomManagement')
      },
      // 笔试考务管理 - 笔试资格管理
      {
        path: "/writtenExam/writtenStatus",
        name: "writtenStatus",
        component: () => import(/* webpackChunkName: "refund" */ '@/views/writtenExam/writtenStatus')
      },
      // 笔试考务管理 - 考场管理
      {
        path: "/writtenExam/appointmentManagement",
        name: "roomManagement",
        component: () => import(/* webpackChunkName: "refund" */ '@/views/writtenExam/appointmentManagement')
      },
    ]
  },
  // 营销管理
  {
    path: '/',
    name: 'marketingAdmin',
    component: Home,
    children: [
      // 营销管理 - 文件资料下载
      {
        path: '/marketingAdmin/dataDownload',
        name: 'DataDownload',
        component: () => import('@/views/marketingAdmin/dataDownload')
      },
      // 营销管理 - 宣传素材管理
      {
        path: '/marketingAdmin/publicity',
        name: 'Publicity',
        component: () => import('@/views/marketingAdmin/publicity')
      },
      // 营销管理 - 招生话术管理
      {
        path: '/marketingAdmin/technicalDialogue',
        name: 'TechnicalDialogue',
        component: () => import('@/views/marketingAdmin/technicalDialogue')
      },
    ]
  },
  // 商户管理
  {
    path: '/',
    name: 'payMerchant',
    component: Home,
    children: [
      // 商户管理 - 商户号管理
      {
        path: '/payMerchant/payMerchantMan',
        name: 'payMerchantMan',
        component: () => import('@/views/payMerchant/payMerchantMan')
      }
    ]
  },
  // 习题管理
  {
    path: '/',
    name: 'exercisesAdmin',
    component: Home,
    children: [
      // 分类管理
      {
        path: "/exercisesAdmin/typeAdmin",
        name: "exercisesAdmintypeAdmin",
        component: () => import(/* webpackChunkName: "exercisesAdmin" */ '@/views/exercisesAdmin/typeAdmin')
      },
      // 题目管理
      {
        path: "/exercisesAdmin/subjectAdmin",
        name: "exercisesAdminsubjectAdmin",
        component: () => import(/* webpackChunkName: "exercisesAdmin" */ '@/views/exercisesAdmin/subjectAdmin')
      },
      // 试卷管理
      {
        path: "/exercisesAdmin/testPaper",
        name: "exercisesAdmintestPaper",
        component: () => import(/* webpackChunkName: "exercisesAdmin" */ '@/views/exercisesAdmin/testPaper')
      },
      {
        path: "/exercisesAdmin/testPaper/detail",
        name: "app1_exercisesAdmin_testPaper",
        component: () => import(/* webpackChunkName: "exercisesAdmin" */ '@/views/exercisesAdmin/testPaper/com/detail')
      }
    ]
  },
  // 实体证书管理
  {
    path: '/',
    name: 'certificate',
    component: Home,
    children: [
      // 领取证书管理
      {
        path: "/certificate/getManage",
        name: "certificateGetManage",
        component: () => import(/* webpackChunkName: "exercisesAdmin" */ '@/views/certificate/getManage')
      },
      // 证书套打申请
      {
        path: "/certificate/printManage",
        name: "certificatePrintManage",
        component: () => import(/* webpackChunkName: "exercisesAdmin" */ '@/views/certificate/printManage')
      },
      // 证书打印池
      {
        path: "/certificate/printPool",
        name: "certificatePrintPool",
        component: () => import(/* webpackChunkName: "exercisesAdmin" */ '@/views/certificate/printPool')
      },
      // 证书申领管理
      {
        path: "/certificate/getCertificate",
        name: "certificateGetCertificate",
        component: () => import(/* webpackChunkName: "exercisesAdmin" */ '@/views/certificate/getCertificate')
      },
    ]
  },
  // 销售工作台
  {
    path: '/',
    name: 'analyse',
    component: Home,
    children: [
      // 参训材料审核
      {
        path: "/analyse/materialsAudit",
        name: "MaterialsAudit",
        component: () => import(/* webpackChunkName: "analyse" */ '@/views/analyse/materialsAudit/index.vue')
      }
    ]
  }
]

const router = new VueRouter({
  mode: "history",
  base: window.__POWERED_BY_QIANKUN__ ? "/app1" : process.env.BASE_URL,
  routes,
});

export default router;
